<template>
  <a-row>
    <a-col class="map_container">
      <div id="map"></div>
    </a-col>  
    <a-col class="detail_data_container">
      <div class="points_panel">
        <div>
          <p>第 {{currentPointIndex + 1 >= 10 ? currentPointIndex + 1 : `0${currentPointIndex + 1}`}}/{{currentPointInfo.totalPointsNum}} 筆</p>
          <p>
            <span><img src="../../assets/icons/map_clock_icon.svg" alt=""></span>
            {{moment(currentPointInfo.time).format('HH:mm:ss')}}
          </p>
          <p>
            <span><img src="../../assets/icons/detail_car_status.svg" alt="" class="detail_car_ststus"></span>
            {{currentPointInfo.speed}} km/h
          </p>
          <p>
            <span>
              <img src="../../assets/icons/map_location_icon.svg" alt="" class="detail_location">
            </span>
            {{currentPointInfo.coordinate[0]}}, {{currentPointInfo.coordinate[1]}}
          </p>
        </div>
        <div>
          <button @click="switchToPrePoint" :class="dataAlreadyFirstStyle">
            <img v-if="dataAlreadyFirstStyle" src="../../assets/icons/pre_point_end.svg" alt="">
            <img v-else src="../../assets/icons/pre_point.svg" alt="">
            上一點
          </button>
          <button @click="turnToPointsListPage">查看點位列表</button>
          <button @click="switchToNextPoint" :class="dataAlreadyLastStyle">
            <img v-if="dataAlreadyLastStyle" src="../../assets/icons/next_point_end.svg" alt="">
            <img v-else src="../../assets/icons/next_point.svg" alt="">
            下一點
          </button>
        </div>
      </div>
    </a-col>  
  </a-row>
</template>

<script>
import Map from "ol/Map";
import View from "ol/View";
import { Tile as TileLayer, Vector as VectorLayer} from 'ol/layer';
import { XYZ } from 'ol/source';
import VectorSource from 'ol/source/Vector';
import { fromLonLat, transformExtent } from 'ol/proj';
import Feature from 'ol/Feature';
import { Style, Stroke, Icon } from 'ol/style';
import LineString from 'ol/geom/LineString';
import { defaults } from "ol/control";
import { GeoJSON } from 'ol/format';
import { Point } from 'ol/geom';

// 假資料
import { testScheduleListData } from "../../assets/testScheduleListData";
import drivingIcon from "../../assets/icons/car_status_driving.svg";
import { boundingExtent } from 'ol/extent';
import {defaults as defaultInteractions} from 'ol/interaction'

// 圖磚URL
const url = 'https://wa-hotaiopen.azurewebsites.net/map/npkget.ashx?z={z}&x={x}&y={y}';
const dafaultPosition = [121.4591572, 25.0601437];
// 限制地圖可拖拉的範圍界限(因為地圖縮到很小時，超出圖磚範圍的地方會有空白，故限制可拖拉的大概範圍為整個台灣本島)
const extentBound = boundingExtent([[118.230796, 21.707473], [123.229752, 25.60011]]);
// 設定圖磚的圖層
const tileLayer = new TileLayer({
  source: new XYZ({
    url,
  }),
});

const styles = {
  // 路徑線條樣式
  route: new Style({
    stroke: new Stroke({
      width: 6,
      color: '#95acf7',
    }),
  }),
  routeBorder: new Style({
    stroke: new Stroke({
      width: 2,
      color: '#B3DFEE',
    }),
  }),
  // 行駛中marker樣式
  driving: new Style({
    image: new Icon({
      anchorXUnits: 'fraction',
      anchorYUnits: 'fraction',
      src: drivingIcon,
    }),
}),
};




export default {
  data() {
    return {
      // 因為地圖下方有資訊區塊，為了使marker在畫面中間，故將中心點的緯度偏移0.0005
      mapCenter: fromLonLat([dafaultPosition[0], dafaultPosition[1] - 0.0005]),
      zoom: 14,
      map: null,
      // 存放所有的點，以繪製路徑
      schedulePoints: [],
      currentPointInfo: {
        totalPointsNum: 0,
        time: '',
        speed: '',
        coordinate: [],
      },
      currentPointIndex: 0,
    }
  },
  mounted() {
    this.initiateMap();
  },
  methods: {
    initiateMap() {
      this.map = new Map({
        target: "map",
        layers: [tileLayer],
        view: this.view,
        controls: defaults({
          zoom: false, // 關閉左上角的縮放按鈕控件
        }),
        interactions: defaultInteractions({
          pinchRotate: false // 移動端禁止地圖旋轉
        }),
      });
      
      // 測試資料的有些物件裡面座標經緯度是空的，會導致路徑畫不出來，故用filter過濾掉空座標
      const filterScheduleListData = testScheduleListData['60f2997a2f200a00122fcfc5'].filter(obj => obj.gps.lon && obj.gps.lat);
      // 將所有點的座標以陣列方式儲存
      this.schedulePoints = filterScheduleListData.map(obj => [obj.gps.lon, obj.gps.lat]);
      // 取得該行程總共有幾個點
      this.currentPointInfo.totalPointsNum = filterScheduleListData.length;
      // 寫入預設第一個點的時間、速度、座標
      this.currentPointInfo.time = filterScheduleListData[this.currentPointIndex].tick;
      this.currentPointInfo.speed = filterScheduleListData[this.currentPointIndex].can.speed;
      this.currentPointInfo.coordinate = [filterScheduleListData[this.currentPointIndex].gps.lon, filterScheduleListData[this.currentPointIndex].gps.lat];
      // 將地圖中心點變為預設的第一個點
      this.map.getView().setCenter(fromLonLat(this.currentPointInfo.coordinate));

      this.map.addLayer(this.routeLayer);
      this.map.addLayer(this.pointLayer);
    },
    switchToNextPoint() {
      if (this.currentPointIndex === (this.currentPointInfo.totalPointsNum - 1)) return;
      else this.currentPointIndex++;
    },
    switchToPrePoint() {
      if (this.currentPointIndex === 0) return;
      else this.currentPointIndex--;
    },
    turnToPointsListPage() {
      this.$router.push(`/individual/schedule/points`);
    },
  },
  computed: {
    // 設定地圖的視圖
    view: function() {
      return new View({
        center: this.mapCenter,
        zoom: this.zoom,
        minZoom: 7,
        maxZoom: 18,
        extent: transformExtent(extentBound, 'EPSG:4326', 'EPSG:3857'),
      })
    },
    routeSource: function() {
      // 以路徑(LineString)的方式新增要素(feature)
      const routeFeature = new Feature({
          type: 'route',
          geometry: new LineString(this.schedulePoints)
          .transform('EPSG:4326', 'EPSG:3857'),
        });

      // 將要素放到數據來源(source)裡面
      return new VectorSource({
        features: [routeFeature],
      })
    },
    pointSource: function() {
      // 剛載入時，預設以第一個點建立Feature
      const pointFeature = new Feature({
          geometry: new Point(fromLonLat(this.currentPointInfo.coordinate)),
          type: 'driving',
        });

      return new VectorSource({
        features: [pointFeature],
        format: new GeoJSON(),
      })
    },
    routeLayer: function() {
      const layer = new VectorLayer({
        source: this.routeSource,
        style: feature => [styles[feature.get('type')], styles.routeBorder],
      });

      return layer;
    },
    pointLayer: function() {
      const layer = new VectorLayer({
        source: this.pointSource,
        style: feature => styles[feature.get('type')],
      });

      return layer;
    },
    dataAlreadyFirstStyle: function() {
      return this.currentPointIndex === 0  ? 'disabled_btn_first' : '';
    },
    dataAlreadyLastStyle: function() {
      return this.currentPointIndex === this.currentPointInfo.totalPointsNum - 1 ? 'disabled_btn_last' : '';
    },
  },
  watch: {
    currentPointIndex: function() {
      this.map.removeLayer(this.pointLayer);
      // 寫入預設目前點的時間、速度、座標
      const filterScheduleListData = testScheduleListData['60f2997a2f200a00122fcfc5'].filter(obj => obj.gps.lon && obj.gps.lat);
      this.currentPointInfo.time = filterScheduleListData[this.currentPointIndex].tick;
      this.currentPointInfo.speed = filterScheduleListData[this.currentPointIndex].can.speed;
      this.currentPointInfo.coordinate = [filterScheduleListData[this.currentPointIndex].gps.lon, filterScheduleListData[this.currentPointIndex].gps.lat];

      // 將地圖中心點變為目前的點
      this.map.getView().setCenter(fromLonLat(this.currentPointInfo.coordinate));

      this.map.addLayer(this.pointLayer);
    }
  },
};
</script>

<style scoped lang="scss">
  @import "../../assets/scss/global.scss";
  @import "../../../node_modules/ol/ol.css";
  
  .map_container {
    height: calc((100vh - 89px) * 0.7);
    #map {
        margin: 0;
        padding: 0;
        height: 100%;
        width: 100%;
        background-color: rgb(163, 203, 255);
    }
  }
  .detail_data_container {
    height: calc((100vh - 89px) * 0.3);
    // padding: 10px 12px;
    box-shadow: 0px 0px 0.8px rgba(0, 0, 0, 0.06), 
    0px 0px 2px rgba(0, 0, 0, 0.04), 
    0px 0px 5px rgba(0, 0, 0, 0.04), 
    0px 0px 17px rgba(0, 0, 0, 0.03);
    .points_panel {
      height: 100%;
      display: flex;
      justify-content: space-between;
      div {
        &:first-child {
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          padding: 8px 12px;
          p {
            margin-bottom: 0;
            color: #343741;
            display: flex;
            &:first-child {
              font-weight: 500;
            }
            span {
              width: 23px;
              display: inline-flex;
              justify-content: center;
              align-items: center;
              img {
                margin-right: 10px;
              }
            }
            .detail_car_ststus {
              width: 15px;
            }
            .detail_location {
              width: 12px;
            }
          }
        }
        &:last-child {
          flex-basis: 140px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          padding: 8px 12px;
          button {
            background: #FFFFFF;
            border: 1px solid rgba(19, 34, 149, 0.1);
            box-sizing: border-box;
            border-radius: 8px;
            padding: 6px 11px;
            line-height: 24px;
            color: rgba(0, 0, 0, 0.85);
            img {
              margin-right: 9px;
            }
          }
          button.disabled_btn_first, button.disabled_btn_last {
            background: #E5E5E5;
            color: rgba(0, 0, 0, 0.25);
          }
        }
      }
    }
  }
  
  @media (max-width: 320px) {
    .detail_data_container {
      .points_panel {
        div {
          &:first-child {
            p {
              font-size: 13px;
            }
          }
        }
      }
    }
  }
</style>